<template>
  <div>
    <div class="row mb-3">
      <div class="col-12 col-md-8 col-lg-6">
        <a-image-card @show-dialog="showImageDialog = true" />
      </div>
    </div>
    <div class="row">
      <div class="d-flex col-12 col-md-8 col-lg-6">
        <button
          v-t="'Config.UserProfile.ProfilePreferences.BackToProfilePage'"
          type="button"
          class="btn btn-pf-secondary ml-auto"
          @click="navigateToUserProfile"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ImageCard from "./components/image-card";

export default {
  components: {
    "a-image-card": ImageCard
  },

  methods: {
    navigateToUserProfile() {
      this.$router.push({ name: "config.userprofile" });
    }
  }
};
</script>
